import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumReducer(state = initialState.verumbcm, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMBCM_SUCCESS:
      return action.verumbcm;

    default:
      return state;
  }
}
